import * as React from 'react';
import classNames from 'classnames';
import {PropsWithChildren} from "react";

export interface INestedMenuWrapperProps extends PropsWithChildren {
    level: string;
    /** Open state */
    open?: boolean;
    /** Inform parent */
    setHasOpenSubMenu?: (val) => void;
    /** ID */
    id?: string;
    children?: React.ReactNode;
}

const NestedMenuWrapper: React.FunctionComponent<INestedMenuWrapperProps> = (props) => {
    const [open, setOpen] = React.useState<string | null>(null);

    const setOpenSubMenu = (val) => {
        setOpen(val);
        if(props.setHasOpenSubMenu){
            if(val) {
                props.setHasOpenSubMenu(true);
            } else {
                props.setHasOpenSubMenu(false);
            }
        }
    };


    return props.open===undefined || props.open ? (
        <div className={classNames('nested-menu', 'nested-menu-' + props.level)}>
            {React.Children.map(props.children, (child, index) => {
                if (typeof child === 'string' || typeof child === 'number' || child === null) {
                    return child;
                } else {
                    if (React.isValidElement(child)) {
                        if (typeof child.type === 'function') {
                            const id = 'menuitem-'+index;
                            const extendedProps = {
                                open,
                                id,
                                setOpenSubMenu,
                            };
                            return React.cloneElement(child, extendedProps);
                        } else {
                            return child;
                        }
                    }
                    return null;
                }
            })}
        </div>
    ) : null;
};

NestedMenuWrapper.displayName = 'NestedMenuWrapper';

export default NestedMenuWrapper;
